import * as THREE from "three"
import Heatpoint from "../heatpointscontrol/heatpoint"
import gsap from "gsap"

export default class fabric extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, model, gltfanimations, mixer, visitedPinColor) {
		super()
		if (!this.originalMaterial) {
			this.originalMaterial = model.children[4].material.clone()
		}

		this.model = model.children[4].material

		this.whiteMaterial = this.model
		this.whiteMaterial.map = null
		this.whiteMaterial.metalnessMap = null
		this.whiteMaterial.normalMap = null
		this.whiteMaterial.roughnessMap = null
		this.whiteMaterial.color.setHex(0xffffff)
		this.whiteMaterial.metalness = 0.5
		this.whiteMaterial.roughness = 0.5
		this.whiteMaterial.needsUpdate = true

		this.model = this.whiteMaterial

		this.pinModel6 = new Heatpoint(null, "model/heatointfabric.glb")
		setTimeout(() => {
			this.pinModel6.setColor(pinColor)
		}, 1000)
		this.visited = false

		this.pinModel6.position.set(-2.03, 0.4, -0.67)

		interactionManager.add(this.pinModel6)

		this.pinModel6.addEventListener("click", (event) => {
			onPinClick()
			gsap.to(camera.position, {x: -3.1, y: 0.9, z: -1.3, duration: 2.5, ease: "Power3.inOut"})
			this.visited = true
			this.triggerAnimations(model, true, gltfanimations, mixer)
		})

		this.pinModel6.addEventListener("mouseover", (event) => {
			document.body.style.cursor = "pointer"
			this.pinModel6.setColor(pinColorDark)
		})
		this.pinModel6.addEventListener("mouseout", (event) => {
			document.body.style.cursor = "default"
			if (!this.visited) {
				this.pinModel6.setColor(pinColor)
			} else {
				this.pinModel6.setColor(visitedPinColor)
			}
		})
		this.add(this.pinModel6)

		this.rotationAngle = 0
		this.rotatePin()
	}

	triggerAnimations(model, modal, gltfanimations, mixer, originalMaterial) {
		const startIndex = 29
		const endIndex = 33
		const animations = gltfanimations
		const actions = []

		for (let i = startIndex; i <= endIndex; i++) {
			const clip = animations[i]
			const action = mixer.clipAction(clip)

			action.setLoop(THREE.LoopOnce, 1).clampWhenFinished = true
			actions.push(action)
		}
		actions.forEach((clip) => {
			clip.reset()
			clip.timeScale = 1
			clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true
		})

		setTimeout(() => {
			model.children[4].material = this.originalMaterial
		}, 4500)

		if (modal) {
			const modal6 = document.getElementById("modal6")
			setTimeout(() => {
				modal6.classList.remove("hidden")
			}, 4500)

			modal6.addEventListener("click", function () {
				this.whiteMaterial = model.children[4].material
				this.whiteMaterial.map = null
				this.whiteMaterial.metalnessMap = null
				this.whiteMaterial.normalMap = null
				this.whiteMaterial.roughnessMap = null
				this.whiteMaterial.color.setHex(0xffffff)
				this.whiteMaterial.metalness = 0.5
				this.whiteMaterial.roughness = 0.5
				this.whiteMaterial.needsUpdate = true
				model.children[4].material = this.whiteMaterial

				actions.forEach((clip) => {
					clip.reset()
					clip.timeScale = -1 // Play the animation backwards
					clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true
				})
			})
		}
	}

	resetAnimations(model, gltfanimations, mixer) {
		this.whiteMaterial = model.children[4].material
		this.whiteMaterial.map = null
		this.whiteMaterial.metalnessMap = null
		this.whiteMaterial.normalMap = null
		this.whiteMaterial.roughnessMap = null
		this.whiteMaterial.color.setHex(0xffffff)
		this.whiteMaterial.metalness = 0.5
		this.whiteMaterial.roughness = 0.5
		this.whiteMaterial.needsUpdate = true
		model.children[4].material = this.whiteMaterial

		const startIndex = 29
		const endIndex = 33
		const animations = gltfanimations
		const actions = []

		for (let i = startIndex; i <= endIndex; i++) {
			const clip = animations[i]
			const action = mixer.clipAction(clip)
			clip.timeScale = -1
			action.setLoop(THREE.LoopOnce, 1).clampWhenFinished = true
			actions.push(action)
		}
		actions.forEach((clip) => {
			clip.reset()
			clip.timeScale = -1 // Play the animation backwards
			clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true
		})
	}

	rotatePin() {
		this.rotationData = {angle: 0}
		gsap.to(this.rotationData, {
			angle: "+=" + 2 * Math.PI, // Add 360 degrees in radians
			duration: 10, // Define how fast you want a full rotation to be. Here it's set to 5 seconds.
			ease: "none", // Linear rotation
			onUpdate: () => {
				this.pinModel6.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle)
			},
			repeat: -1 // This will make the animation run indefinitely
		})
	}
}
